import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Navigate, useParams } from 'react-router-dom'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import {
  advertiserShareFallbackPath,
  isBudgetTableShared,
} from '../shareScenarioVisibility'
import DraftReviewList from './DraftReviewParts/DraftReviewList'
import DraftReviewWindow from './DraftReviewParts/DraftReviewWindow'

export default observer(function DraftReview() {
  const { action_id, id } = useParams()
  const { campaignScenarios, isLoading, campaign } = useContext(SharedCampaignContext)
  const { isCollapsed: isCampaignSidebarCollapsed } = useSidebarCollapse()
  const primaryScenario = campaignScenarios[0]
  const leftOffset = isCampaignSidebarCollapsed ? 64 : 224

  if (!isLoading && !isBudgetTableShared(campaign)) {
    return (
      <Navigate
        to={`/advertiser/campaign_share/${id}/${advertiserShareFallbackPath({ scenario: primaryScenario, campaign })}`}
        replace
      />
    )
  }

  return (
    <div className="fixed top-0 w-full h-full bg-rb-grey dark:bg-rb-dark-mode-background transition-all duration-300" style={{ left: `${leftOffset}px`, width: `calc(100vw - ${leftOffset}px)` }}>
      <DraftReviewList />
      { action_id && <DraftReviewWindow />}
    </div>
  )
})